import { render } from "./Chips.vue?vue&type=template&id=c733f9d0&scoped=true"
import script from "./Chips.vue?vue&type=script&lang=js"
export * from "./Chips.vue?vue&type=script&lang=js"

import "./Chips.vue?vue&type=style&index=0&id=c733f9d0&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/prod-fe-app-myqampus/node_modules/vue-cli-plugin-vue-next/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c733f9d0"]])

export default __exports__